import React, { useEffect } from 'react';
import { useAuth } from './AuthProvider';
import { LoginScreen } from './LoginScreen';

export const AuthGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }
  }, [isAuthenticated]);

  if (isLoading) {
    return (
      <div className="potentia-auth-shell">
        <div className="potentia-auth-content">
          <div className="panel-surface potentia-auth-loading">
            <div className="potentia-auth-loading-dot" />
            <p className="potentia-auth-loading-text">Checking your Potentia session...</p>
          </div>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <LoginScreen />;
  }

  return <>{children}</>;
};
